import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toastr from 'toastr';

const API_BASE = process.env.REACT_APP_TENANT_API || 'https://htb4wmezrg.execute-api.us-west-2.amazonaws.com/prod';

const CreateMSP = () => {
  const [formData, setFormData] = useState({
    name: '',
    slug: '',
    email: ''
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
      // Auto-generate slug from name if slug field is empty
      ...(name === 'name' && !formData.slug ? { slug: value.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '') } : {})
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/v2/msp/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to create MSP');
      }

      const result = await response.json();
      toastr.success(`MSP created successfully! Subdomain: ${result.subdomain}`);
      navigate('/dashboard/msps');
    } catch (error) {
      console.error('Error creating MSP:', error);
      toastr.error(error.message || 'Failed to create MSP');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Create New MSP</h2>
      <div className="card mt-4">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">MSP Name *</label>
              <input
                type="text"
                className="form-control"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="e.g., Noventiq, Comquest"
                required
              />
              <small className="text-muted">The display name of the MSP</small>
            </div>

            <div className="mb-3">
              <label className="form-label">Slug *</label>
              <input
                type="text"
                className="form-control"
                name="slug"
                value={formData.slug}
                onChange={handleChange}
                placeholder="e.g., noventiq, comquest"
                pattern="[a-z0-9-]+"
                required
              />
              <small className="text-muted">
                Subdomain identifier (lowercase, no spaces). Will be: <strong>{formData.slug || 'slug'}.odir.com</strong>
              </small>
            </div>

            <div className="mb-3">
              <label className="form-label">Admin Email *</label>
              <input
                type="email"
                className="form-control"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="admin@msp.com"
                required
              />
              <small className="text-muted">Root admin user for this MSP (will receive invitation email)</small>
            </div>

            <div className="alert alert-info">
              <strong>Note:</strong> Creating an MSP will:
              <ul className="mb-0 mt-2">
                <li>Create MSP record in database</li>
                <li>Create root admin user in Cognito</li>
                <li>Send invitation email to admin</li>
                <li>Enable subdomain: <strong>{formData.slug || 'slug'}.odir.com</strong></li>
              </ul>
            </div>

            <div className="d-flex gap-2">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'Creating MSP...' : 'Create MSP'}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate('/dashboard/msps')}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateMSP;